import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { USER_LOGOUT } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { UserLogoutDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadUserLogout =
  (): ThunkAction<Promise<void>, State, null, UserLogoutDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: USER_LOGOUT + REQUEST });
    try {
      const payload = await api.loadLogoutUser();
      localStorage.clear();
      dispatch({ type: USER_LOGOUT + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: USER_LOGOUT + FAILURE, error });
    }
  };
